import {fromJS} from 'immutable';
import {
  SET_IS_PHOTO_CAPTURE_OPEN,
  SET_CAPTURED_IMAGE,
  SET_PHOTO_CAPTURE_WIZARD_STEP,
  SET_WHOS_IN_THE_PHOTO,
  IS_SHOW_PHOTO_OPEN,
  IS_PHOTO_CAPTURE_OPEN,
  PHOTO_CAPTURE_WIZARD_STEP,
  WHO_IS_IN_THE_PHOTO,
  SHOW_PHOTO_URL,
  CAPTURED_IMAGE,
  IS_CAMERA_ENABLED,
  SET_IS_CAMERA_ENABLED,
  CAPTURED_IMAGE_TIME, SET_IS_SHOW_PHOTO_OPEN,
} from './consts'

const initialState = fromJS({
  [IS_PHOTO_CAPTURE_OPEN]: false,
  [PHOTO_CAPTURE_WIZARD_STEP]: 0,
  [CAPTURED_IMAGE]: null,
  [CAPTURED_IMAGE_TIME]: null,
  [WHO_IS_IN_THE_PHOTO]: '',
  [IS_SHOW_PHOTO_OPEN]: false,
  [SHOW_PHOTO_URL]: '',
  [IS_CAMERA_ENABLED]: true,
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_PHOTO_CAPTURE_OPEN:
      return state.set(IS_PHOTO_CAPTURE_OPEN, action.isOpen)

    case SET_CAPTURED_IMAGE:
      return state.set(CAPTURED_IMAGE, action.image)
        .set(CAPTURED_IMAGE_TIME, action.image ? Date.now() : null)

    case SET_PHOTO_CAPTURE_WIZARD_STEP:
      return state.set(PHOTO_CAPTURE_WIZARD_STEP, action.step)

    case SET_WHOS_IN_THE_PHOTO:
      return state.set(WHO_IS_IN_THE_PHOTO, action.text)

    case SET_IS_SHOW_PHOTO_OPEN:
      console.log('gizim', 1003100, 'action.isOpen', action.isOpen, 'action.url', action.url);

      return state.set(IS_SHOW_PHOTO_OPEN, action.isOpen)
        .set(SHOW_PHOTO_URL, action.url)

    case SET_IS_CAMERA_ENABLED:
      return state.set(IS_CAMERA_ENABLED, action.payload.enabled)

    default:
      return state
  }
}
